import React from 'react';
import { Link } from 'react-router-dom';
import './About.css';

const HERO_IMG = '/inside2.png';
const FOOD_IMG = '/food1.png';

export default function About() {
  return (
    <main>
      <div className="page-hero">
        <img src={HERO_IMG} alt="Restaurant interior" />
        <div className="page-hero-content">
          <p style={{ fontFamily: 'Cormorant Garamond, serif', fontStyle: 'italic', fontSize: '1rem', letterSpacing: '0.2em', color: 'var(--gold-pale)', marginBottom: '0.5rem' }}>Our Story</p>
          <h1>Discover My Story</h1>
          <a href="tel:5869484900" className="phone-link">586-948-4900</a>
        </div>
      </div>

      <div className="gold-bar" />

      {/* About Company */}
      <section className="section">
        <div className="container about-grid">
          <div className="about-text">
            <h2 className="section-title">About the Company</h2>
            <div className="divider-ornament"><span>✦</span></div>
            <p>
              Giuseppe's Restaurant is an Italian restaurant located in Chesterfield, Michigan,
              and it's been in business since 1999. That's more than 25 years of filling hungry
              bellies with authentic Italian fare!
            </p>
            <p>
              Our founder's passion for Italian cooking began in the old country, where every
              meal was an act of love and every ingredient told a story. That same philosophy
              drives everything we do today.
            </p>
          </div>
          <div className="about-stat-block">
            <div className="about-stat">
              <strong>25+</strong>
              <span>Years Serving<br />Chesterfield</span>
            </div>
            <div className="about-stat">
              <strong>1999</strong>
              <span>Year Founded</span>
            </div>
          </div>
        </div>
      </section>

      {/* Dishes Section */}
      <section className="about-dishes">
        <div className="about-dishes__img">
          <img src={FOOD_IMG} alt="Italian dishes" />
        </div>
        <div className="about-dishes__text">
          <h2 className="section-title">Italian Dishes<br />Lovingly Created</h2>
          <div className="divider-ornament"><span>✦</span></div>
          <p>
            Discover flavorful Italian food made with locally-sourced produce. Every dish is
            prepared using farm-fresh ingredients and time-honored homemade recipes passed
            down through generations.
          </p>
          <p>
            Aside from the day-to-day dining fare, Giuseppe's Restaurant also offers catering
            services for various special occasions. The restaurant also hosts events at the
            banquet hall.
          </p>
          <p>Contact us for reservations — we'd love to host your next celebration.</p>
          <div style={{ marginTop: '2.5rem', display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
            <Link to="/menu" className="btn-primary">View the Menu</Link>
            <Link to="/contact" className="btn-outline">Reserve a Table</Link>
          </div>
        </div>
      </section>

      {/* Service Areas */}
      <section className="section service-areas">
        <div className="container">
          <h2 className="section-title" style={{ textAlign: 'center' }}>Service Areas in Michigan</h2>
          <div className="divider-ornament"><span>✦</span></div>
          <div className="areas-grid">
            {['Chesterfield Township', 'Clinton Township', 'Macomb Township', 'New Baltimore'].map(area => (
              <div className="area-card" key={area}>
                <span className="area-card__dot" />
                <span>{area}</span>
              </div>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}
